import {Button} from "../ui-components/button.tsx";
import clsx from "clsx";
import {ChannelsFilterType} from "../pages/main/ChannelsBlock.tsx";

export type AvailableChannelsFilterType = "all" | "chosen" | "notChosen";

type FilterItem<T> = {
    id: number;
    title: string;
    filterVal: T;
    border?: boolean;
};

interface CommonFilterBtnBlockProps<T> {
    data: FilterItem<T>[];
    filterState: T;
    onChange: (val: T) => void;
}

export const CommonFilterBtnBlock = <T extends ChannelsFilterType | AvailableChannelsFilterType>({
                                                                                                     data,
                                                                                                     onChange,
                                                                                                     filterState,
                                                                                                 }: CommonFilterBtnBlockProps<T>) => {

    return (
        <div className="w-full flex gap-2">
            {data.map((item) => {
                const onChangeFilterHandler = () => {
                    onChange(item.filterVal);
                };
                const selected = item.filterVal === filterState
                return (
                    <Button onClick={onChangeFilterHandler}
                            key={item.id}
                            color={selected ? 'dark/white' : 'white'}
                            className={clsx(`flex items-center text-nowrap whitespace-nowrap overflow-hidden !text-sm !font-medium !px-4 !py-[7px] !leading-4 rounded-full before:!bg-inherit`,
                                {
                                    '!text-white !bg-black': selected,
                                    '!text-black !bg-inherit': !selected
                                })}>
                        {item.title}
                    </Button>
                );
            })}
        </div>
    );
};
